/**
 * A language's flag, drawn (D-189).
 *
 * Drawn rather than an emoji: flag emoji are two letters on Windows, so a
 * child on a school laptop would see "GB" where everyone else sees a flag. The
 * same two drawings as the settings mockup (19). A language with no drawing
 * gets a globe, and the name is always beside it either way.
 */

import { flagFor } from './language.js';

export default function Flag({ l2 }: { readonly l2: string }) {
  if (l2 === 'en') {
    return (
      <svg
        width="24"
        height="16"
        viewBox="0 0 60 40"
        aria-hidden="true"
        style={{ borderRadius: 3 }}
      >
        <rect width="60" height="40" fill="#012169" />
        <path d="M0 0 60 40M60 0 0 40" stroke="#FFF" strokeWidth="8" />
        <path d="M0 0 60 40M60 0 0 40" stroke="#C8102E" strokeWidth="3" />
        <path d="M30 0v40M0 20h60" stroke="#FFF" strokeWidth="12" />
        <path d="M30 0v40M0 20h60" stroke="#C8102E" strokeWidth="7" />
      </svg>
    );
  }
  if (l2 === 'sv') {
    return (
      <svg
        width="24"
        height="16"
        viewBox="0 0 16 10"
        aria-hidden="true"
        style={{ borderRadius: 3 }}
      >
        <rect width="16" height="10" fill="#006AA7" />
        <path d="M5 0v10M0 5h16" stroke="#FECC00" strokeWidth="2" />
      </svg>
    );
  }
  return <span aria-hidden="true">{flagFor(l2)}</span>;
}
